import { Order } from '@typings';
import { useTranslation } from 'react-i18next';

export const useOrderStatusLabels = (): Record<Order.Status, string> => {
  const { t } = useTranslation(['orders']);

  return {
    cancelled: t('orders:stage_cancelled'),
    checkoutCompleted: t('orders:stage_completed'),
    checkoutRequested: t('orders:stage_checkout_requested'),
    completed: t('orders:stage_completed'),
    inProgress: t('orders:stage_in_progress'),
    open: t('orders:stage_open'),
    pending: t('orders:stage_pending'),
  };
};
